import React from 'react';
import { graphql } from 'gatsby';
import { Pannellum } from 'pannellum-react';
// import { FacebookProvider, Like } from 'react-facebook';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Header from '../components/header';
import Booking from '../components/booking';
import Slider from '../components/slider';

export const query = graphql`
  query RoomQuery($order: Int!) {
    contentfulRoom(order: { eq: $order }) {
      id
      title
      photos {
        id
        file {
          url
        }
        fluid(maxWidth: 200, resizingBehavior: SCALE) {
          ...GatsbyContentfulFluid_tracedSVG
        }
      }
      panorama {
        file {
          url
        }
      }
      description {
        json
      }
      promo
      prices
      beds
      maxPeople
      order
    }
    allContentfulContacts {
      edges {
        node {
          id
          type
          value
        }
      }
    }
  }
`;

const RoomPage = ({
  data: {
    contentfulRoom: {
      title,
      description: { json: description },
      photos,
      promo,
      beds,
      panorama: {
        file: { url: panorama },
      },
      maxPeople,
      prices,
      order,
    },
    allContentfulContacts: { edges: rawContacts },
  },
  location,
}) => {
  const monthes = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ];
  const contacts = {};
  // eslint-disable-next-line no-return-assign
  rawContacts.forEach(({ node: { type, value } }) => (contacts[type] = value));

  const currentPrice = prices[new Date().getMonth()];

  return (
    <Layout>
      <SEO
        lang="ru"
        title={title}
        keywords={[
          title,
          promo,
          `описание ${title}`,
          `бронирование ${title}`,
          'бронирование',
          `отзывы ${title}`,
          'отель',
          'гостевой',
          'дом',
          'hotel',
          'guest',
          'house',
          'dom',
          'yalta',
          'гостевой дом',
          'guest house',
          'dom_yalta',
          'аренда жилья в ялте 2019',
          'отдых в ялте 2019',
          'семейный отдых',
        ]}
        description={documentToPlainTextString(description)}
      />
      <Header contacts={contacts} location={location} sticky />
      <main className="main">
        <div className="container">
          <div className="pagecontent">
            <div className="container">
              <div className="row flex-wrap">
                <div className="col-xs-12 col-sm-8 content">
                  <div className="title-group">
                    <h1 className="title-1">{title}</h1>
                    {/* <div className="stars-group">
                      <FacebookProvider appId="416595472429323">
                        <Like
                          href={`https://dom-yalta.ru/room/${order}`}
                          colorScheme="light"
                          layout="button"
                          action="recommend"
                          size="small"
                          lang="ru"
                          share
                        />
                      </FacebookProvider>
                    </div> */}
                  </div>
                  <div className="section room-info">
                    <div className="room-description">
                      {typeof window !== 'undefined' && Pannellum && (
                        <Pannellum
                          width="100%"
                          image={panorama}
                          pitch={0}
                          yaw={180}
                          hfov={110}
                          autoLoad
                          showZoomCtrl
                          autoRotate={-5}
                        />
                      )}
                    </div>
                    <div id="yandex_rtb_R-A-599273-1"></div>
                    <script
                      id="gatsby-plugin-yandex-direct"
                      key={`gatsby-plugin-yandex-direct`}
                      dangerouslySetInnerHTML={{
                        __html: `(function(w, d, n, s, t) {
                          w[n] = w[n] || [];
                          w[n].push(function() {
                            Ya.Context.AdvManager.render({
                              blockId: "R-A-599273-1",
                              renderTo: "yandex_rtb_R-A-599273-1",
                              async: true
                            });
                          });
                          t = d.getElementsByTagName("script")[0];
                          s = d.createElement("script");
                          s.type = "text/javascript";
                          s.src = "//an.yandex.ru/system/context.js";
                          s.async = true;
                          t.parentNode.insertBefore(s, t);
                        })(this, this.document, "yandexContextAsyncCallbacks");`
                      }}
                    />
                  </div>
                  <div className="section room-photo">
                    <h2 className="title-2">Фото</h2>
                    <Slider photos={photos} />
                  </div>
                  <div className="section room-info">
                    <div className="room-description">
                      <h2 className="title-2">{promo}</h2>
                      <div className="row row--baseline flex-wrap description-panel">
                        <div className="col-xs-12 col-sm-2 description-title">Обзор:</div>
                        <div className="col-xs-12 col-sm-8 description-content">
                          <p>{beds}</p>
                          <p>{`Вместимость: ${maxPeople} чел.`}</p>
                        </div>
                      </div>
                      <div className="row row--baseline flex-wrap description-panel">
                        <div className="col-xs-12 col-sm-2 description-title">Описание:</div>
                        <div className="col-xs-12 col-sm-10">
                          <div className="paragraph">{documentToReactComponents(description)}</div>
                        </div>
                      </div>
                    </div>
                    <div className="room-description">
                      <h2 className="title-2">Информация по бронированию</h2>
                      <div className="row row--baseline flex-wrap description-panel">
                        <div className="col-xs-12 col-sm-12">
                          <p className="alert alert-success">Возврат залога при отмене более чем за 30 дней до заезда</p>
                        </div>
                      </div>
                      <div className="row row--baseline flex-wrap description-panel">
                        <div className="col-xs-12 col-sm-2 description-title">Цены:</div>
                        <div className="col-xs-12 col-sm-8">
                          <ul className="amenities-list">
                            {prices.map((price, i) => (
                              <li key={i} className="amenities-item">
                                <span className="bold">
                                  {`${monthes[i]}:`}
                                  &nbsp;
                                </span>
                                <span>{` ${price}р`}</span>
                              </li>
                            ))}
                          </ul>
                          <span>
                            В этом месяце стоимость:
                            <span className="bold">{` ${currentPrice} руб/ночь`}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4 sidebar">
                  <div className="box-container">
                    <Booking room={title} prices={prices} />
                  </div>
                  <div className="box-container">
                    <div className="box-title">Контакты</div>
                    <div className="box-content">
                      <ul className="contacts-list">
                        <li className="contacts-item address">{contacts.address}</li>
                        <li className="contacts-item email">
                          <a className="contacts-link" href={`mailto:${contacts.email}`}>
                            {contacts.email}
                          </a>
                        </li>
                        <li className="contacts-item phone">
                          <a className="contacts-link" href={`tel:${contacts.phone}`}>
                            {contacts.phone}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box-container">
                    <div className="box-content">
                      <div id="yandex_rtb_R-A-599273-3"></div>
                      <script
                        id="gatsby-plugin-yandex-direct"
                        key={`gatsby-plugin-yandex-direct`}
                        dangerouslySetInnerHTML={{
                          __html: `(function(w, d, n, s, t) {
                          w[n] = w[n] || [];
                          w[n].push(function() {
                              Ya.Context.AdvManager.render({
                                  blockId: "R-A-599273-3",
                                  renderTo: "yandex_rtb_R-A-599273-3",
                                  async: true
                              });
                          });
                          t = d.getElementsByTagName("script")[0];
                          s = d.createElement("script");
                          s.type = "text/javascript";
                          s.src = "//an.yandex.ru/system/context.js";
                          s.async = true;
                          t.parentNode.insertBefore(s, t);
                      })(this, this.document, "yandexContextAsyncCallbacks");`
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default RoomPage;
